import { useEffect, useState } from 'react'
import { AnalyticsConsentCard } from './analytics/AnalyticsConsent'
import { HomepageV3Footer, HomepageV3Header } from './components/HomepageV3Chrome'
import { cartBoxCount } from './order/cartStorage'
import './styles/about-v2.css'

function Arrow() {
  return <span className="sg-v3-arrow" aria-hidden="true">→</span>
}

export default function AboutPage() {
  const [cartCount, setCartCount] = useState(() => cartBoxCount())

  useEffect(() => {
    const refreshCart = () => setCartCount(cartBoxCount())
    window.addEventListener('storage', refreshCart)
    const timer = window.setInterval(refreshCart, 500)
    return () => {
      window.clearInterval(timer)
      window.removeEventListener('storage', refreshCart)
    }
  }, [])

  return (
    <div className="sg-v3 about-v2">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <HomepageV3Header cartCount={cartCount} activeHref="/about" />

      <main id="main-content" tabIndex={-1}>
        <section className="about-v2-hero" aria-labelledby="about-title">
          <div className="sg-v3-shell about-v2-hero__grid">
            <div className="about-v2-hero__copy">
              <p className="sg-v3-eyebrow">ABOUT SUGAR GREMLIN</p>
              <h1 id="about-title">WE’RE THE HUMANS<br />BEHIND THE <strong>GREMLIN.</strong></h1>
              <p className="about-v2-hero__intro">
                A small, home-based bakery in Christchurch making big flavours, properly indulgent bakes and a little bit of Gremlin chaos.
              </p>
            </div>

            <div className="about-v2-hero__visual">
              <img
                className="about-v2-hero__stamp"
                src="/assets/about/sg-about-hero-stamp-approved.png"
                alt="Small Batch Christchurch Weekly Drop"
              />
              <span className="about-v2-hero__ray about-v2-hero__ray--one" aria-hidden="true" />
              <span className="about-v2-hero__ray about-v2-hero__ray--two" aria-hidden="true" />
              <span className="about-v2-hero__ray about-v2-hero__ray--three" aria-hidden="true" />
            </div>
          </div>
        </section>

        <section className="about-v2-story" aria-labelledby="about-story-title">
          <div className="sg-v3-shell about-v2-story__grid">
            <div className="about-v2-photo-wrap">
              <div className="about-v2-photo-hearts" aria-hidden="true">
                <span>♡</span><span>♡</span>
              </div>
              <img
                className="about-v2-photo"
                src="/assets/about/sg-about-family-photo-v1.jpg"
                width="1086"
                height="1448"
                alt="Kyle, Kathy and Aurora, the family behind Sugar Gremlin"
                decoding="async"
              />
              <div className="about-v2-photo-note" aria-hidden="true">
                <span>OUR<br />LITTLE<br />CREW</span>
                <b>↗</b>
                <i>♡</i>
              </div>
            </div>

            <div className="about-v2-story__copy">
              <div className="about-v2-story__heading-wrap">
                <h2 id="about-story-title">JUST THE TWO OF US.<br /><strong>AND A LOT OF COOKIES.</strong></h2>
              </div>

              <p>We’re <strong>Kyle and Kathy</strong> — husband and wife, parents, and the two slightly sleep-deprived humans behind Sugar Gremlin.</p>

              <p>It started with a simple idea from Kyle’s mum: <strong>brownie cookies with buttercream in the middle.</strong> We did some digging, realised there wasn’t much like it around, and thought:</p>

              <p className="about-v2-story__statement"><strong>Yeah… we can do something with this.</strong></p>

              <p>Kathy is the baker. She develops flavours, gets the recipes right, and somehow makes the chaos taste good.</p>

              <p>Kyle handles the website, orders, marketing, business stuff and, in his own words:</p>

              <p className="about-v2-story__statement"><strong>“I just do what I’m told in the kitchen.”</strong></p>

              <p>There have been dry brownies, exploding fillings, buttercream disasters and more than one last-minute ingredient run.</p>

              <p className="about-v2-story__highlight"><strong>Kathy also has a mildly annoying habit of being right about flavours Kyle thinks won’t work.</strong></p>

              <p>Cookie Dough? Worked.<br />Toasted Coconut? Worked.</p>

              <p>We’re still not talking about it.</p>

              <p>Sugar Gremlin is proudly <strong>small-batch, handmade and imperfect</strong>.</p>

              <p>The cookies won’t all look identical.</p>

              <p>The buttercream might not be perfectly symmetrical.</p>

              <p>That’s because two actual people made them — not a machine.</p>

              <p>We’re building this for our family, including <strong>Aurora and our angel baby Mason</strong>, and hopefully creating something our kids can be proud of one day.</p>

              <div className="about-v2-story__kicker">
                <p><strong>No glamorized bullshit.</strong></p>
                <p><strong>Just good cookies, big flavours, and a little Gremlin chaos.</strong></p>
              </div>

              <div className="about-v2-story__action">
                <a className="sg-v3-button sg-v3-button--pink" href="/order">BUILD YOUR BOX <Arrow /></a>
                <span className="about-v2-story__action-rays" aria-hidden="true">///</span>
              </div>
            </div>
          </div>
        </section>

        <section className="about-v2-final" aria-labelledby="about-final-title">
          <div className="sg-v3-shell about-v2-final__inner">
            <div>
              <p className="sg-v3-eyebrow">ENOUGH ABOUT US</p>
              <h2 id="about-final-title">LET’S GET TO<br /><strong>THE GOOD STUFF.</strong></h2>
            </div>
            <div className="about-v2-final__action">
              <p>Pick this week’s flavours, mix your favourites and build a box.</p>
              <a className="sg-v3-button sg-v3-button--pink" href="/order">ORDER NOW <Arrow /></a>
            </div>
          </div>
        </section>
      </main>

      <HomepageV3Footer />
      <AnalyticsConsentCard />
    </div>
  )
}